import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import MobileBackGroundImage from "../../../assets/image/mobile-background/mobile-bg-03.jpg";
import { useNavigate } from "react-router-dom";
import Typo from "../../common/Typo";
import { useFormik } from "formik";
import { stepFiveSchema } from "../../../data/schema";
import TextFiled from "../../common/TextFiled";
import smileMediumImg from '../../../assets/image/blink-smile.png.png'
import smileMobileImg from '../../../assets/image/mobile-blink-smile.png'
import RadioButton from "../../common/RadioButton";
import { setQulificationStore } from "../../../redux/reducers/getData";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Loader from "../../common/Loader";
import Card from "../../common/Card";
import Footer from "../../common/Footer";
import { EmailSmallIcon, PhoneSmallIcon } from "../../../assets/icon";
import { ToastContainer, toast, Bounce } from 'react-toastify'
import API_CONFIG from '../../../config/config'

const { apiURL } = API_CONFIG;

const useStyles = makeStyles((theme) => ({
  animation: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '10px',
    maxHeight: '78vh',
    overflowY: 'scroll',
    animation: `$lauchTime 600ms ${theme.transitions.easing.easeInOut}`
  },
  "@keyframes lauchTime": {
    "0%": {
      transform: "translateX(200%)",
    },
    "100%": {
      transform: "translateX(0)",
    }
  },
  smileImag: {
    backgroundImage: `url(${smileMediumImg})`,
    height: '50px',
    width: '50px'
  },
  nxtbutton: {
    marginTop: "40px",
    animation: `$lauchTime 200ms ${theme.transitions.easing.easeInOut}`
  },
  form: {
    display: 'flex',
    rowGap: '1.250rem',
    flexDirection: 'column',
  },
  error: {
    color: 'red',
    fontWeight: 500,
    fontSize: '0.625rem', //10px
    lineHeight: '0.875rem', //14px
    margin: '8px 0 0 5px',
    fontFamily: 'Object Sans',
  },
  stepFourContentDiv: {
    maxWidth: '825px',
    display: 'grid',
    columnGap: '1rem',
    gridTemplateColumns: '1.8fr 1fr',
    margin: '2.5rem'
  },
  reviText: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
    marginTop: '0.625rem'
  },
  phoneCallsLabel: {
    textOverflow: 'clip',
  },
  "@media (max-width: 1000px)": {
    animation: {
      padding: '0 20px',
      maxWidth: '100%',
    },
    smileImag: {
      backgroundImage: `url(${smileMobileImg})`,
      height: '24px',
      width: '24px'
    },
    reviText: {
      width: '100%',
      maxWidth: '100%',
      display: 'block',
      margin: '0.55rem'
    },
    body: {
      backgroundImage: `url(${MobileBackGroundImage})`,
      width: "100vw",
      height: "auto",
    },
    stepFourContentDiv: {
      width: '100%',
      maxWidth: '100%',
      gridTemplateColumns: '1fr',
      margin: '0.55rem'
    },
    error: {
      margin: '0px'
    },
    form: {
      margin: '2rem 0'
    },
    phoneCallsLabel: {
      textOverflow: 'ellipsis',
    },
  },
}));

function StepFour({ setStepThree, setStepFour }) {
  const classes = useStyles();
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [phoneNumberError, setPhoneNumberError] = useState([])
  const [emailReapeatError, setEmailReapeatError] = useState([])

  const myState = useSelector((state) => state.user)
  const PreFiledBasicContactInformation = useSelector((state) => state.user.basicContactInformation)

  // payload object 
  const basicInformation = {
    first_name: myState?.basicInformation?.first_name,
    last_name: myState?.basicInformation?.last_name,
    business_name: myState?.basicInformation?.business_name,
    locations_count: myState?.basicInformation?.locations_count,
    business_types: myState?.outerBussinessType,
    custom_business_type: myState?.otherBusinessName,
    average_customers_count_start: myState?.passData?.average_customers_count_start,
    average_customers_count_end: myState?.passData?.average_customers_count_end,
    average_bill_start: myState?.passData?.average_bill_start,
    average_bill_end: myState?.passData?.average_bill_end
  }
  //

  // set signupid into store
  const dispatch = useDispatch()

  // API call
  const userPost = async () => {
    try {
      setIsLoading(true)
      // make POST request using Axios
      const response = await axios.post(apiURL + '/signup/qualification/', basicInformation);

      // handle successful response
      if (response.status === 201) {
        setIsLoading(false)
        var signUpData = response?.data?.signup
        var signUpID = response?.data?.signup?.id
        dispatch(setQulificationStore({ signUpData })) // id direct store in redux
        dispatch(setQulificationStore({ basicInformation })) // basic information store in redux
        navigate(`/plan/${signUpID}`)
      }
    } catch (error) {
      setEmailReapeatError(error?.response?.data?.email)
      setIsLoading(false)
      setPhoneNumberError(error?.response?.data?.phone_number)
      toast.error('Oops, something went wrong. Please try again.', {
        style: { width: '100%' },
        closeButton: false
      });
    }
  }
  //

  //01
  const setSubmitting = (value) => {
    basicInformation['phone_number'] = value.number
    basicInformation['email'] = value.email
    basicInformation['preferable_communication'] = value.prefired
  }

  //form submission
  const { handleChange, handleSubmit, values, errors, handleBlur, touched } = useFormik({
    initialValues: {
      email: PreFiledBasicContactInformation?.email,
      number: PreFiledBasicContactInformation?.phone_number,
      prefired: PreFiledBasicContactInformation?.preferable_communication
    },
    touched: {
      email: '',
      number: '',
      prefired: ''
    },
    validationSchema: stepFiveSchema,

    onSubmit: async (value) => {
      let basicContactInformation = {
        email: value?.email,
        phone_number: value?.number,
        preferable_communication: value?.prefired
      }
      setSubmitting(value)
      userPost()
      dispatch(setQulificationStore({ basicContactInformation }))
    }
  })

  const handleBackPage = () => {
    setStepThree(true)
    setStepFour(false)
  }
  //
  return (
    <form onSubmit={handleSubmit}>
      {isLoading && <Loader />}
      <div className={classes.animation}>

        <div className={classes.reviText}>
          <Typo variant='os03G'>Don’t worry! We won’t spam you. </Typo>
          <div className={classes.smileImag} />
        </div>

        <Card className={classes.stepFourContentDiv}>
          <div>
            <Typo variant='pp09'>Enter your email and phone number and select your preferred form of contact.  </Typo>
            <br />
            <br />
            <Typo variant='pp09'>Revi uses your contact information to save your progress and confirmation emails.</Typo>

          </div>

          <div className={classes.form} >

            <TextFiled
              id="email"
              name="email"
              value={values.email}
              onChange={handleChange}
              placeholder="Email Address"
              label="Email Address"
              required
              defaultValue={PreFiledBasicContactInformation?.email}
              onBlur={handleBlur}
              touched={touched.email}
              errors={errors.email || emailReapeatError}
              icon={<EmailSmallIcon />}
            />

            <TextFiled
              id="number"
              name="number"
              value={values.number}
              onChange={handleChange}
              placeholder="Phone Number"
              label="Phone Number"
              required
              defaultValue={PreFiledBasicContactInformation?.phone_number}
              onBlur={handleBlur}
              touched={touched.number}
              errors={errors.number || phoneNumberError}
              icon={<PhoneSmallIcon />}
            />

            <RadioButton
              name="prefired"
              label="I prefer to receive EMAILS"
              onChange={handleChange}
              value={'emails'}
              errors={errors.prefired}
              defaultValue={PreFiledBasicContactInformation?.preferable_communication}
            />

            <RadioButton
              name="prefired"
              label="I prefer to receive PHONE CALLS"
              labelClassName={classes.phoneCallsLabel}
              onChange={handleChange}
              value={'phone_calls'}
              errors={errors.prefired}
              defaultValue={PreFiledBasicContactInformation?.preferable_communication}
            />
            {touched.prefired ? <Typo className={classes.error}>{errors.prefired}</Typo> : null}

          </div>
        </Card>
      </div>
      <Footer
        buttonText="Submit"
        onSubmit={handleSubmit}
        handleBackPage={handleBackPage}
        isDisable={true}
      />
      <ToastContainer
        width={100}
        theme="colored"
        autoClose={3000}
        position="bottom-right"
        transition={Bounce}
      />
    </form>
  );
}

export default StepFour;